import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {

  constructor(
    private http: HttpClient
  ) { }

  getCustomContactInfo(): Observable<string> {
    return this.http.get<string>(`${environment.API_BASE}/Contacto/CustomInfo`).pipe(first());
  }

  // 🥑🥑SRR 29/10/2020
  getDatosVideoInicial(): Observable<string> {
    return this.http.get<string>(`${environment.API_BASE}/Contacto/CustomVideoInicial`).pipe(first());

  }
}
